module.exports = __webpack_public_path__ + "img/24.553292ee.png";